
// import { CollapseComponent } from 'angular-bootstrap-md or ng-uikit-pro-standard';
import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';


export class NgbdCollapseBasic {
  public isCollapsed = false;
  public isCollapsed2 = false;
  public isCollapsed3 = false;
}

export class AboutItem {
  title: string;
  description: string;
}



@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
  // selector: 'ngbd-collapse-basic',
  // templateUrl: './collapse-basic.html'
})


export class AboutComponent implements OnInit {

public itemsList: AboutItem[] = [
  {
    title: 'Collapsible Group Item #1',
    description: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid1.'
  },
  {
    title: 'Collapsible Group Item #2',
    description: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid2.'
  },
  {
    title: 'Collapsible Group Item #3',
    description: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.'
  }
];



/*
  @ViewChildren(CollapseComponent) collapses: CollapseComponent[];

  ngAfterViewInit() {
      this.collapses.forEach((collapse: CollapseComponent) => {
        collapse.toggle();
      });
  }*/
  constructor() { }

  ngOnInit() {
  }


}
